import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { checkSoftwareUpdate } from './api/api'
import { buildUpdateDialogContent } from './utils/updateText'
import ToastPlugin from './plugins/toast'
import pkg from '../package.json'
Vue.use(ElementUI)
Vue.use(ToastPlugin)

Vue.config.productionTip = false

function maybePromptUpdate () {
  try {
    console.info('[update-check] start calling checkSoftwareUpdate')
    checkSoftwareUpdate()
      .then(res => {
        console.info('[update-check] response:', res)
        const body = res && res.data ? res.data : res
        const data = body && body.data ? body.data : body
        const backendVer = data && data.version
        const url = data && (data.downloadUrl || data.url)
        const updateText = data && data.text
        const currentVer = pkg && pkg.version
        console.log(currentVer)
        // 仅依据后端update标志与版本差异决定是否弹窗
        const needUpdate = Boolean(data && data.update === true && backendVer && currentVer && backendVer !== currentVer)
        if (!needUpdate) return
        const baseMsg = backendVer ? `发现新版本 ${backendVer}，请下载更新。` : '发现新版本，请下载更新。'
        const dialog = buildUpdateDialogContent(baseMsg, updateText)
        Vue.prototype.$confirm(
          dialog.html,
          '版本更新',
          {
            confirmButtonText: '下载更新',
            type: 'info',
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          if (url) {
            try { window.open(url, '_blank') } catch (e) { window.location.href = url }
          }
        }).catch(() => {})
      })
      .catch((err) => {
        console.warn('[update-check] request failed:', err)
      })
  } catch (e) { /* noop */ }
}

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    this.$nextTick(() => {
      try {
        const isLogin = window.localStorage.getItem('isLogin') === 'true'
        if (!isLogin) {
          console.info('[update-check] skipped at startup: not logged in')
          return
        }
        // 刷新后统一检查更新
        maybePromptUpdate()
      } catch (e) {}
    })
  }
}).$mount('#app')
